import { api } from '../core';
import { TIMELINE_TAG, TIMELINE_UNDO_REDO_HISTORY_TAG } from '../constants';

export interface TimelineEntriesSlotInRequest {
  caseId: string;
  entryIds: string[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface TimelineEntriesSlotInResponse {}

const timelineEntriesSlotInApi = api.injectEndpoints({
  endpoints: (builder) => ({
    slotInTimelineEntries: builder.mutation<TimelineEntriesSlotInResponse, TimelineEntriesSlotInRequest>({
      query: (body: TimelineEntriesSlotInRequest) => ({
        url: `/timeline/entries/slot-in`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _err, { caseId }) => [
        { type: TIMELINE_TAG, id: caseId },
        { type: TIMELINE_UNDO_REDO_HISTORY_TAG, id: caseId },
      ],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useSlotInTimelineEntriesMutation } = timelineEntriesSlotInApi;
